"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
/**Componente que muestra un selector con botones */
class ButtonSelector extends React.PureComponent {
    onClick(value) {
        if (this.props.onChange)
            this.props.onChange(value);
    }
    render() {
        return (React.createElement("ul", { className: "pagination pagination-sm" }, (this.props.items || [])
            .map((x, i) => React.createElement("li", { key: x.value == null ? ("__null" + i) : (x.value + ""), className: x.disabled ? "disabled" :
                this.props.value == x.value ? "active" : "" },
            React.createElement("a", { 
                /**Arreglo del z index, el selector activo sale por encima de los drop downs de los combos */
                style: { zIndex: 0 }, title: x.tooltip ? (x.tooltip + "") : "", onClick: x.disabled ? undefined : (() => this.onClick(x.value)) }, x.label)))));
    }
}
exports.ButtonSelector = ButtonSelector;
/**Componente que muestra un selector de botones paginado, útil cuando existen demasiadas opciones  */
class PaginatedButtonSelector extends React.PureComponent {
    constructor(props) {
        super(props);
        this.PageSize = 10;
        this.handleOnChange = (value) => {
            if (!this.props.onChange)
                return;
            const index = this.CurrentIndex || 0;
            const items = this.Items;
            if (value == "_next") {
                this.props.onChange(this.GetValueAt(Math.min(items.length - 1, index + 1)));
            }
            else if (value == "_previous") {
                this.props.onChange(this.GetValueAt(Math.max(0, index - 1)));
            }
            else {
                this.props.onChange(value);
            }
        };
    }
    /**Todos los items */
    get Items() {
        return this.props.items || [];
    }
    GetValueAt(index) {
        const it = this.Items[index];
        if (it.disabled)
            throw new Error("No se puede obtener el valor de un item que esta deshabilitado");
        return it.value;
    }
    get CurrentIndex() {
        return this.GetIndex(this.props.value);
    }
    GetIndex(value) {
        const items = this.Items;
        for (var i = 0; i < items.length; i++) {
            if (items[i].value == value)
                return i;
        }
        return null;
    }
    /**Elementos de la página actual */
    get PageItems() {
        const pageCount = this.PageCount;
        const items = this.Items;
        //Si no hay paginas, devolvemos items, que seria un arreglo vacio
        if (pageCount <= 1)
            return this.Items;
        const page = this.CurrentPage;
        const pageItems = this.Items.slice(this.CurrentPage * this.PageSize, (this.CurrentPage + 1) *
            this.PageSize);
        const pageSize = this.PageSize;
        //Agregamos los puntos suspensivos al principio o al final de la lista:
        const dots = { value: undefined, label: "...", disabled: true };
        if (page > 0) {
            const lastPageItem = (page - 1) * pageSize;
            pageItems.splice(0, 0, dots);
            if (lastPageItem != 0)
                pageItems.splice(0, 0, items[lastPageItem]);
            pageItems.splice(0, 0, items[0]);
        }
        if (page < (pageCount + 1)) {
            const lastItem = items.length - 1;
            const nextPageItem = Math.min(lastItem, (page + 2) * pageSize - 1);
            pageItems.push(dots);
            if (nextPageItem != lastItem)
                pageItems.push(items[nextPageItem]);
            pageItems.push(items[items.length - 1]);
        }
        pageItems.splice(0, 0, { value: "_previous", label: '«' });
        pageItems.push({ value: "_next", label: '»' });
        return pageItems;
    }
    /**Indice seleccionado */
    get SelectedIndex() {
        var index = this.CurrentIndex;
        if (index === undefined)
            return null;
        else
            return index;
    }
    /**Pagina actual */
    get CurrentPage() {
        return Math.floor((this.SelectedIndex || 0) / this.PageSize);
    }
    /**Cantidad de páginas */
    get PageCount() {
        return Math.ceil(this.Items.length / this.PageSize);
    }
    render() {
        return (React.createElement(ButtonSelector, { items: this.PageItems, value: this.props.value, onChange: this.handleOnChange }));
    }
}
exports.PaginatedButtonSelector = PaginatedButtonSelector;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/selector/buttonSelector.js
// module id = 2252
// module chunks = 0